//
//
//
//
//
//

export default {
    props: {
        plaidUrl: {
            type: String,
            default: 'https://cdn.plaid.com/link/v2/stable/link-initialize.js'
        }
    },
    created: function created() {
        this.loadScript(this.plaidUrl).then(this.onScriptLoaded).catch(this.onScriptError);
    },
    beforeDestroy: function beforeDestroy() {
        if (window.linkHandler) {
            window.linkHandler.exit();
        }
    },

    methods: {
        onScriptLoaded: function onScriptLoaded() {
            window.linkHandler = window.Plaid.create({
                clientName: 'Madera',
                env: process.env.MIX_PLAID_ENV,
                key: process.env.MIX_PLAID_PUBLIC_KEY,
                product: ['auth', 'transactions'],
                selectAccount: true,
                webhook: 'https://app.maderaresidential.com/hooks/plaid',
                onSuccess: function onSuccess(public_token, metadata) {
                    axios.post('/prototype/accounting/bank-accounts/create', { token: public_token, metadata: metadata }).then(function (response) {
                        Event.$emit('refresh-bank-accounts');
                    });
                }
            });
        },
        add: function add() {
            if (window.linkHandler) {
                window.linkHandler.open();
            }
        },
        loadScript: function loadScript(src) {
            return new Promise(function (resolve, reject) {
                if (document.querySelector('script[src="' + src + '"]')) {
                    resolve();
                    return;
                }
                var el = document.createElement('script');
                el.type = 'text/javascript';
                el.async = true;
                el.src = src;
                el.addEventListener('load', resolve);
                el.addEventListener('error', reject);
                el.addEventListener('abort', reject);
                document.head.appendChild(el);
            });
        }
    }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-loader/lib?{"cacheDirectory":true,"presets":[["env",{"modules":false,"targets":{"browsers":["> 2%"],"uglify":true}}]],"plugins":["transform-object-rest-spread",["transform-runtime",{"polyfill":false,"helpers":false}]],"env":{"test":{"presets":[["env",{"targets":{"node":"current"}}]]},"development":{"presets":[["env",{"modules":false}]]},"production":{"presets":[["env",{"modules":false,"targets":{"browsers":"> 2%","uglify":true}}]]}}}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./resources/assets/js/components/accounting/banking/AddBankAccount.vue
// module id = cANB
// module chunks = 0 1